'use strict';

module.exports = /(^|_)([^_]+)/g;